import { render, staticRenderFns } from "./SupplierPrices.vue?vue&type=template&id=2b24feb2&scoped=true&"
import script from "./SupplierPrices.vue?vue&type=script&lang=js&"
export * from "./SupplierPrices.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPrices.vue?vue&type=style&index=0&id=2b24feb2&scoped=true&lang=css&"
import style1 from "./SupplierPrices.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24feb2",
  null
  
)

export default component.exports